import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { Button } from "../../components";
import {
  LeftGreenLine,
  Dome,
  Radius,
  backend,
  cyber,
  dataAnalysis,
  dm,
  frontend,
  gameDev,
  pd,
  prodMgt,
  projectMgt,
  qa,
  web3,
} from "../../assets/";
import {
  landingButton,
  ecllips,
  domeImgWrapper,
  landingMainWrapper,
  landingMain,
  landingWrapper,
  landingHeader,
  landingText,
  landingButtonWrapper,
  greenWrap,
  landingButtonWrapperCenter,
  marqueeContainer,
  marqueeTrack,
  iconBox,
} from "./landingPage.module.css";
import { SponsorATalent } from "../sponsorATalent/SponsorATalent";
import { AlertContext } from "../../context/context";
import { toast } from "react-toastify";
import axios from "axios";
import { EndPoints } from "../../api";

const LandingPage = () => {
  const history = useHistory();
  const { setAlertState } = useContext(AlertContext);
  const [applicationClose, setApplicationClose] = useState(false);

  sessionStorage.setItem(
    "paySuccess",
    JSON.stringify({
      show: true,
      labelText:
        "Thanks, your payment was successful. Check email for instructions",
      failure: false,
      status: "Success",
      type: "Application payment",
    })
  );

  const paymentAlert = JSON.parse(sessionStorage.getItem("paySuccess"));

  useEffect(() => {
    const searchParams = new URLSearchParams(history.location.search);
    const status = searchParams.get("status");

    if (status === "success") {
      setAlertState(paymentAlert);
    }
  }, [history.location.search]);

  useEffect(() => {
    axios
      .get(EndPoints.main)
      .then((res) => {
        setApplicationClose(res.data?.user_application_closed);
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {});
  }, []);

  const handleClick = () => {
    axios
      .get(EndPoints.main)
      .then((res) => {
        if (res.data.user_application_closed) {
          toast.error("Application closed");
        } else {
          history.push("/application");
        }
      })
      .catch((err) => {
        console.log("err", err);
      })
      .finally(() => {});
  };

  return (
    <div className={landingWrapper}>
      <SponsorATalent />

      <Radius className={ecllips} />

      <div className={landingMainWrapper}>
        <div className={greenWrap}>
          <img src={LeftGreenLine} alt="green line" />
        </div>
        <div className={landingMain}>
          <div>
            <h1 className={landingHeader}>
              Everything Is Learnable. Are You Ready?
            </h1>
          </div>
          <div>
            <p className={landingText}>
              Kickstart your tech career by enrolling in our state of the art
              internship program. You don't want to miss this! You can
              contribute to the production of the next tech stars by sponsoring
              a talent!
            </p>
          </div>

          <div
            className={
              applicationClose
                ? landingButtonWrapperCenter
                : landingButtonWrapper
            }
          >
            {!applicationClose && (
              <Button
                className={landingButton}
                buttonName="Application Form"
                main="fill"
                onClick={handleClick}
              />
            )}
            <Button
              className={landingButton}
              buttonName="Sponsor a Talent"
              data-toggle="modal"
              data-target="#sponsorTalentModal"
            />
          </div>
        </div>
      </div>
      <div className={domeImgWrapper}>
        <Marquee />
      </div>
    </div>
  );
};
export { LandingPage };

const ICONS = [
  backend,
  cyber,
  dataAnalysis,
  frontend,
  gameDev,
  pd,
  qa,
  prodMgt,
  dm,
  projectMgt,
  web3,
];

const Marquee = () => {
  const marqueeIcons = [...ICONS, ...ICONS];

  return (
    <div className={marqueeContainer}>
      <div className={marqueeTrack}>
        {marqueeIcons.map((icon, index) => (
          <div key={index} className={iconBox}>
            <img src={icon} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
